import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export async function fetchNewContent() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/contents?type=new`
  );

  return data;
}

export async function fetchFreeContent() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/contents?type=free`
  );

  return data;
}

export async function fetchNewCollection() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/collections/new`
  );

  return data;
}

export async function fetchFreeCollection() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/collections/free`
  );

  return data;
}
